import { Card } from "antd";
import { OrderHistory } from "../../orders/components/OrderHistory";

export function TransacionsCard() {
  return  <Card size="small">
    <OrderHistory />
  </Card>
}